<template>
  <div class="live-monitor" v-if="monitorList.length">
    <div class="live-video">
      <live-video v-for="(item,index) in videoList" :dynamicClass="dynamicClass" :key="index" :url="item.url" :index="index"  @error="changeError"/>
    </div>
    <section class="page"><span class="up" @click="up" :class="{pageturn:this.page==0}" >上一页</span><span @click="down" class="down"  :class="{pageturn:this.page==this.total}" >下一页</span></section>
  </div>
  <div v-else-if="monitorList.length==0&&isLoad" class="live-monitor no-monitor">
    <div class="video-nodata">
      <img src="../../assets/icon_data_empty.png" alt="">
      <span class="nodata-monitor">暂无监控设备，请联系管理员添加</span>
    </div>
  </div>
</template>

<script>
import LiveVideo from '@/components/v2/LiveVideo.vue'
import equipmentV2 from '../../store/modules/equipmentV2'
import indexModule from '../../store/modules/index'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'BaseMap',
  components: {
    LiveVideo
  },
  data () {
    return {
      isLoad: false,
      list: ['http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/2017092513417/dev_20170925133417_itq70exptp5sa470.m3u8', 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/20170925133417/dev_20170925133417_itq70exptp5sa70.m3u8', 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/20170925133417/dev_2017092513417_itq70exptp5sa470.m3u8', 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/20170925133417/dev_2017092513417_itq70exptp5sa470.m3u8', 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/20170925133417/dev_2017092513417_itq70exptp5sa470.m3u8', 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/20170925133417/dev_2017092513417_itq70exptp5sa470.m3u8'],
      monitorList: [
        // 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/20170925133417/dev_20170925133417_itq70exptp5sa470.m3u8',
        // 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/0/1/20170925133417/dev_20170925133417_itq70exptp5sa470.m3u8',
        // 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/2/1/20170925134055/dev_20170925134055_5zl1d7151e67cpha.m3u8',
        // 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/8/1/20170925134529/dev_20170925134529_d1im7ti2cchrqcfk.m3u8',
        // 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/8/1/20170925134529/dev_20170925134529_d1im7ti2cchrqcfk.m3u8',
        // 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/8/1/20170925134529/dev_20170925134529_d1im7ti2cchrqcfk.m3u8',
        // 'http://alhlsgw.lechange.com:9001/LCO/3E00EBAPAZ76A22/8/1/20170925134529/dev_20170925134529_d1im7ti2cchrqcfk.m3u8'
      ],
      pageNum: 6,
      page: 0,
      total: '',
      nodata: '',
      dynamicClass: 'monitor'
    }
  },
  watch: {
    async haveVideoBaseId (value) {
      this.monitorList = []
      this.isLoad = false
      this.monitorList = await this.getVideoMonitoring({
        FishbaseId: this.haveVideoBaseId
      })
      if (this.monitorList.length === 0) {
        this.nodata = true
      }
      setTimeout(() => {
        this.isLoad = true
      }, 1000)
      this.total = Math.ceil(this.monitorList.length / this.pageNum) - 1
    }
  },
  computed: {
    ...mapState(indexModule, ['haveVideoBaseId']),
    ...mapState(equipmentV2, ['basic']),
    videoList () {
      var arr = this.monitorList.map(item => {
        var newItem = {
          showLogo: false,
          url: item
        }
        return newItem
      })
      return arr.slice(this.page * this.pageNum, (this.page + 1) * this.pageNum)
    }
  },
  async created () {
    this.monitorList = []
    this.monitorList = await this.getVideoMonitoring({
      FishbaseId: this.haveVideoBaseId
    })
    if (this.monitorList.length === 0) {
      this.nodata = true
    }
    setTimeout(() => {
      this.isLoad = true
    }, 1000)
    this.total = Math.ceil(this.monitorList.length / this.pageNum) - 1
  },
  async mounted () {
    this.monitorList = []
    this.monitorList = await this.getVideoMonitoring({
      FishbaseId: this.haveVideoBaseId
    })
    if (this.monitorList.length === 0) {
      this.nodata = true
    }
    setTimeout(() => {
      this.isLoad = true
    }, 1000)
    this.total = Math.ceil(this.monitorList.length / this.pageNum) - 1
  },
  methods: {
    ...mapActions(equipmentV2, ['getVideoMonitoring']),
    changeError (num) {
      console.log('视频初始化失败')
    },
    splitArr (arr, num) {
      let result = []
      this.total = Math.ceil(arr.length / num)
      for (let i = 0; i < this.total; i++) {
        var start = i * num
        var end = start + num
        result.push(arr.slice(start, end))
      }
      return result
    },
    up () {
      let value = this.page - 1
      this.page = -1
      this.$nextTick(() => {
        if (value < 0) {
          this.page = 0
        } else {
          this.page = value
        }
      })
    },
    down () {
      let value = this.page + 1
      this.page = -1
      this.$nextTick(() => {
        if (value > this.total) {
          this.page = this.total
        } else {
          this.page = value
        }
      })
    }
  }
}
</script>
<style lang="scss">
.no-monitor{
  height:calc(100vh - 100px);
  position: relative;
}
.video-nodata{
   img{
    display:block;
    width: 218px;
    height: 218px;
    position: absolute;
    left:42%;
    top:30%;
  }
  .nodata-monitor{
    position: absolute;
    left:40%;
    top:64%;
    font-size:20px;
    color:#eee;
  }
}

.wrap{
  height:850px !important;
  >div{
    position:relative;
    flex:0 0 33.33%;
    height:50%;
  }

}
.pageturn{
  pointer-events :none;
  color:grey !important;
}
.live-video{
  height: calc(100vh - 120px);
  margin-top: 10px;
  padding:0 10px;
  display:flex;
  flex-wrap: wrap;
}
.monitor{
  position: relative;
  height: calc((100vh - 120px) / 2 );
  flex:0 0 33.33%;
  video{
    padding:3px;
    width: 100%;
    object-fit:fill;
  }
}
.page{
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color:white;
  span{
    cursor: pointer;
    margin-right: 20px;
  }
}
</style>
